import { Navigate, Outlet } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth.store';
import {
  getFirstAccessibleTab,
  type Workspace,
} from '@/config/navigation';

/**
 * Workspace content shell. The workspace's tabs render in the contextual
 * secondary sidebar (see DashboardLayout), so this is now a thin content
 * wrapper that simply hosts the active tab's page.
 */
export function WorkspaceLayout() {
  return <Outlet />;
}

/**
 * Index element for a workspace base path — redirects to the first tab the
 * current user is allowed to open. Falls back to /dashboard if none.
 */
export function WorkspaceIndexRedirect({ workspace }: { workspace: Workspace }) {
  const hasPermission = useAuthStore((s) => s.hasPermission);
  const tab = getFirstAccessibleTab(workspace, hasPermission);
  if (!tab) return <Navigate to="/dashboard" replace />;
  return <Navigate to={`${workspace.basePath}/${tab.segment}`} replace />;
}
